import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    key: "snow_removal",
    title: "Residential Snow Removal",
    tag: "Winter · Storm-Ready",
    body:
      "Reliable plowing & shovelling for driveways, walkways, and entrances. Crews dispatched on every trigger snowfall so your morning runs on time.",
    bullets: ["Per-storm or seasonal contracts", "Driveway + walkway + steps", "Damage-free equipment"],
    img: "https://images.pexels.com/photos/35030442/pexels-photo-35030442.jpeg",
  },
  {
    key: "salting_deicing",
    title: "Salting & De-Icing",
    tag: "Traction · Liability",
    body:
      "Eco-aware salt and brine applications to keep surfaces walkable and drivable. Slip-and-fall prevention for homes and small commercial sites.",
    bullets: ["Pre-storm & post-plow apps", "Pet-safer blends on request", "On-call freezing-rain response"],
    img: "https://images.unsplash.com/photo-1771544597072-55584e607f10",
  },
  {
    key: "driveway_sealing",
    title: "Driveway Sealing",
    tag: "Summer · Asphalt Care",
    body:
      "Commercial-grade sealcoating that armours asphalt against UV, water, and freeze-thaw. Extends driveway life and gives that deep matte-black finish.",
    bullets: ["Crack-fill prep included", "2-coat application", "Curbside detailing"],
    img: "https://images.unsplash.com/photo-1581037417787-dda6c19e06ad",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <div className="hairline mb-6" data-testid="services-eyebrow">What We Do</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-2xl">
              Two seasons.
              <span className="text-[#C9A24B]"> One shield.</span>
            </h2>
          </div>
          <p className="text-white/65 max-w-md text-base">
            From the first frost to the August heat, one local crew protects your property
            year-round — never juggling contractors again.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {SERVICES.map((s) => (
            <article
              key={s.key}
              data-testid={`service-card-${s.key}`}
              className="group bg-[#0B1B3D] hover:bg-[#0F2554] transition-colors duration-300 p-8 md:p-10 flex flex-col"
            >
              <div className="relative h-56 -mx-8 -mt-8 md:-mx-10 md:-mt-10 mb-8 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B3D] via-[#0B1B3D]/40 to-transparent" />
                <div className="absolute top-4 left-4 text-[10px] tracking-[0.25em] uppercase text-[#9BD0E8] bg-[#050B14]/70 backdrop-blur px-3 py-1.5">
                  {s.tag}
                </div>
              </div>

              <h3 className="font-display text-2xl font-semibold text-white mb-4">
                {s.title}
              </h3>
              <p className="text-white/70 text-sm leading-relaxed mb-6">{s.body}</p>
              <ul className="space-y-2 mb-8">
                {s.bullets.map((b) => (
                  <li
                    key={b}
                    className="text-sm text-white/75 flex items-start gap-3"
                  >
                    <span className="mt-2 h-px w-3 bg-[#C9A24B] flex-shrink-0" />
                    {b}
                  </li>
                ))}
              </ul>
              <a
                href="#quote"
                data-testid={`service-cta-${s.key}`}
                className="mt-auto inline-flex items-center gap-2 text-[#C9A24B] text-sm font-semibold tracking-wide hover:text-[#E0B962] transition-colors"
              >
                Request this service
                <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
